export default __webpack_public_path__ + "static/media/chat-help2.415e4499.png";